import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useStyles } from '../styles';
import { TemplateField } from '../templateField';
import { ruleRowNameSize, ruleRowFieldsSize, row } from '../utils';
import AccountNumber from './accountNumber';
import RuleRowHeader from '../ruleRowHeader';
import { combineClasses } from '../../../utils/styling';

export const Account = props => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid container item xs={row}>
      <Grid item {...ruleRowNameSize} className={classes.EventTypeNameField}>
        <RuleRowHeader
          headerText={t(`templateRuleAccount.${props.transactionType}`)}
          showAddButton={false}
          showDeleteButton={false}
        />
      </Grid>
      <Grid
        container
        item
        justifyContent="flex-start"
        alignItems="stretch"
        {...ruleRowFieldsSize}
        className={combineClasses([classes.RuleFields, classes.RuleAccountRow])}
      >
        <AccountNumber
          transactionType={props.transactionType}
          rule={props.rule}
        />
        {props.rule[props.transactionType].objectMappings
          .filter(m => m.object.active)
          .map(m => (
            <TemplateField
              name={`accountingObject-${m.object.name}`}
              key={m.object.index}
              selectOptions={props.selectOptions}
              transactionType={props.transactionType}
              objectIndex={m.object.index}
              rule={props.rule}
            />
          ))}
      </Grid>
    </Grid>
  );
};

Account.propTypes = {
  selectOptions: PropTypes.object,
  transactionType: PropTypes.string,
  rule: PropTypes.object,
  hover: PropTypes.bool,
};
